import React from "react";
import emoji1 from "../../../../../assets/images/web_rating/emoji_1.gif";
import emoji2 from "../../../../../assets/images/web_rating/emoji_2.gif";
import emoji3 from "../../../../../assets/images/web_rating/emoji_3.gif";
import emoji4 from "../../../../../assets/images/web_rating/emoji_4.gif";
import emoji5 from "../../../../../assets/images/web_rating/emoji_5.gif";

// Array to store emoji images
const emojiImage = [emoji1, emoji2, emoji3, emoji4, emoji5];

const EmojiAnswer = ({ answer, answeres }) => {
  return (
    <div className="answerArea">
      {answer?.question?.options?.find(
        (opt) => opt?._id === answeres[answer?.question?._id]?.value
      )?.value ? (
        <img
          className="w-10 h-10"
          src={
            emojiImage[
              answer?.question?.options?.find(
                (opt) => opt?._id === answeres[answer?.question?._id]?.value
              )?.value - 1
            ]
          }
          alt="emoji-path"
        />
      ) : null}
    </div>
  );
};
export default EmojiAnswer;
